// Spacing — 4px base (DESIGN.md)
export const spacing = {
  scale: {
    xxs: '0.25rem',
    xs: '0.5rem',
    sm: '0.75rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    '2xl': '2.5rem',
    '3xl': '3rem',
    '4xl': '4rem',
    '5xl': '6rem',
    '6xl': '8rem',
    section: '12rem',
    0: '0',
    1: '0.5rem',
    2: '0.75rem',
    3: '1rem',
    4: '1.5rem',
    5: '2rem',
    6: '2.5rem',
    7: '3.5rem',
  },

  component: {
    button: {
      sm: '0 0.5rem',
      md: '0 0.75rem',
      lg: '0 1rem',
      xl: '0 1.5rem',
    },
    input: {
      sm: '0 0.75rem',
      md: '0 0.75rem',
      lg: '0 1rem',
    },
    card: {
      sm: '1rem',
      md: '1.5rem',
      lg: '2rem',
    },
    section: {
      sm: '2rem 0',
      md: '3rem 0',
      lg: '4rem 0',
      xl: '6rem 0',
    },
    container: {
      sm: '0 1rem',
      md: '0 1.5rem',
      lg: '0 2rem',
      xl: '0 2rem',
    },
  },

  layout: {
    header: '4rem',
    sidebar: {
      collapsed: '4rem',
      expanded: '16rem',
    },
    footer: '3rem',
    content: {
      horizontal: '1.5rem',
      vertical: '1.5rem',
    },
    pageMaxWidth: '87.5rem',
  },

  radius: {
    none: '0',
    xs: '0.25rem',
    sm: '0.375rem',
    md: '0.5rem',
    lg: '0.75rem',
    xl: '1rem',
    pillSm: '4rem',
    pill: '100px',
    full: '9999px',
  },

  shadow: {
    sm: '0px 1px 1px rgba(0, 0, 0, 0.02), 0px 2px 2px rgba(0, 0, 0, 0.04)',
    md: '0px 2px 2px rgba(0, 0, 0, 0.04), 0px 8px 8px -8px rgba(0, 0, 0, 0.04)',
    lg: '0px 2px 2px rgba(0, 0, 0, 0.04), 0px 8px 16px -4px rgba(0, 0, 0, 0.04)',
    xl: '0px 1px 1px rgba(0, 0, 0, 0.02), 0px 8px 16px -4px rgba(0, 0, 0, 0.04), 0px 24px 32px -8px rgba(0, 0, 0, 0.06)',
    inner: '0 0 0 1px rgba(0, 0, 0, 0.08) inset',
  },
};

export const getSpacing = (size) => spacing.scale[size] || spacing.scale.md;
export const getComponentSpacing = (component, size) =>
  spacing.component[component]?.[size] || spacing.component[component]?.md;
export const getLayoutSpacing = (element) => spacing.layout[element];
